import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { User } from "../../providers";

@Component({
  selector: "app-class-type-list",
  templateUrl: "./class-type-list.component.html",
})
export class ClassTypeListComponent implements OnInit {
  @Output() classTypeClick: EventEmitter<number> = new EventEmitter();
  classTypes: any[];

  constructor(private _user: User) {}

  ngOnInit() {
    this._user.getClassTypes().subscribe((result) => {
      this.classTypes = result.data;
    });
  }

  handleCategoryClick(classType: any) {
    this.classTypeClick.emit(classType);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/class-type-list/class-type-list.component.ts